export const isMenu = (menus) => ({
    type: "IS_MENU",
    payload: menus,
  });
